import React from 'react';
import { Grid } from '@material-ui/core';

// Import assets
import telganiLogo from 'assets/images/telgani_logo_color.png';

// Import components
import { SignOutButton, LanguageSwitcher } from '../../components';

// Import styles
import { useStyles } from './styles';

export const Header = () => {
	const classes = useStyles();

	return (
		<Grid container spacing={2} alignContent="center">
			<Grid item xs={6} md={12} className={classes.headerActions}>
				<SignOutButton />
				<LanguageSwitcher />
			</Grid>
			<Grid item xs={6} md={12} className={classes.logoContainer}>
				<img className={classes.logo} src={telganiLogo} alt="Telgani logo" />
			</Grid>
		</Grid>
	);
};
